import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7197ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content request" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title request" }, "2-1. ご提供いただきたい情報", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-text request" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "explan-list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "著作者の生年、没年又は死亡時期"),
    /*#__PURE__*/_createElementVNode("li", null, "著作権者のご連絡先"),
    /*#__PURE__*/_createElementVNode("li", null, "（照会すれば上記が判明しそうな）関係機関又は関係者")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("ご提供くださった情報の一部は、著作権関連の手続き以外に、"),
    /*#__PURE__*/_createElementVNode("a", { href: "https://id.ndl.go.jp/auth/ndla/" }, "当館のウェブサービス"),
    /*#__PURE__*/_createTextVNode("で著作者情報として公開させていただく場合があります。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "（著作者の読み仮名、生没年、肩書及び情報源等。ただし、書誌データに採録されない著作者の情報、（著作者以外の）著作権者や情報提供者の情報は除きます。）")
], -1))
const _hoisted_4 = { class: "request-flow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "公開調査中の著作者", -1))
const _hoisted_6 = { class: "content-text request" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 「")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "1. 情報をご提供いただきたい著作者", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("」をご参照ください。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToPageTop = _resolveComponent("ToPageTop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, [
          _hoisted_7,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/openinq/search'))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/openinq/search')), ["prevent"]), ["space","enter"])),
            class: "button-searchResult"
          }, _hoisted_9, 32),
          _hoisted_10
        ])
      ])
    ]),
    _createVNode(_component_ToPageTop)
  ]))
}